var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.60972 4.06866L9.17357 4.48347C9.29959 4.31218 9.3409 4.09289 9.28586 3.88749C9.23083 3.68209 9.0854 3.51284 8.89063 3.4275L8.60972 4.06866ZM12.6332 9.83336C12.6332 12.3923 10.5588 14.4667 7.99984 14.4667V15.8667C11.332 15.8667 14.0332 13.1655 14.0332 9.83336H12.6332ZM7.99984 14.4667C5.44092 14.4667 3.3665 12.3923 3.3665 9.83336H1.9665C1.9665 13.1655 4.66772 15.8667 7.99984 15.8667V14.4667ZM3.3665 9.83336C3.3665 7.27444 5.44092 5.20003 7.99984 5.20003V3.80003C4.66772 3.80003 1.9665 6.50124 1.9665 9.83336H3.3665ZM10.8953 6.21595C11.956 7.06623 12.6332 8.37048 12.6332 9.83336H14.0332C14.0332 7.92773 13.1489 6.22816 11.771 5.12361L10.8953 6.21595ZM4.41886 2.99675L8.3288 4.70982L8.89063 3.4275L4.98069 1.71443L4.41886 2.99675ZM8.04586 3.65386L5.51629 7.09239L6.644 7.922L9.17357 4.48347L8.04586 3.65386Z",
    fill: "#ADBFDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadIcon);
export default __webpack_public_path__ + "static/media/reload-icon.3a86f46873c49d6d47dda87ec2010bec.svg";
export { ForwardRef as ReactComponent };